import {Locale} from './locale';

export const nativeLanguageByLocale: Record<Locale, string> = {
  [Locale.en_ZZ]: 'English',
  [Locale.es_ZZ]: 'Spanish',
  [Locale.de_DE]: 'Deutsch',
  [Locale.en_DE]: 'English',
  [Locale.de_AT]: 'Deutsch',
  [Locale.en_AT]: 'English',
  [Locale.de_CH]: 'Deutsch',
  [Locale.it_CH]: 'Tedesco',
  [Locale.fr_CH]: 'Français',
  [Locale.en_CH]: 'English',
  [Locale.nl_NL]: 'Nederlands',
  [Locale.en_NL]: 'English',
  [Locale.nl_BE]: 'Nederlands',
  [Locale.fr_BE]: 'Français',
  [Locale.pl_PL]: 'język polski',
  [Locale.cs_CZ]: 'český jazyk',
  [Locale.sk_SK]: 'slovenčina',
  [Locale.ro_RO]: 'limba română',
  [Locale.hu_HU]: 'magyar',
  [Locale.sl_SI]: 'slovenščina',
  [Locale.lv_LV]: 'Latviski',
  [Locale.ru_LV]: 'Латышский',
  [Locale.lt_LT]: 'Lietuvių',
  [Locale.et_EE]: 'eesti keel',
  [Locale.ru_EE]: 'Латышский',
  [Locale.hr_HR]: 'Hrvatski',
  [Locale.bg_BG]: 'български',
  [Locale.da_DK]: 'Dansk',
  [Locale.fr_FR]: 'français',
  [Locale.sv_SE]: 'Svenska',
  [Locale.fi_FI]: 'Suomi',
  [Locale.es_ES]: 'Español',
  [Locale.it_IT]: 'Italiano',
  [Locale.pt_PT]: 'Português',
  [Locale.el_GR]: 'Ελληνική Γλώσσα',
  [Locale.el_CY]: 'Ελληνική Γλώσσα',
  [Locale.fr_LU]: 'Français',
};
